export var MACROTYPOLOGY;
(function (MACROTYPOLOGY) {
  /* a.k.a => case */
  MACROTYPOLOGY[MACROTYPOLOGY["RESIDENTIAL"] = 1] = "RESIDENTIAL";
  /* a.k.a => locali commerciali */
  MACROTYPOLOGY[MACROTYPOLOGY["BUSINESS"] = 2] = "BUSINESS";
  /* a.k.a => terreni */
  MACROTYPOLOGY[MACROTYPOLOGY["LAND"] = 3] = "LAND";
  MACROTYPOLOGY[MACROTYPOLOGY["BUILDINGSITE"] = 4] = "BUILDINGSITE";
  MACROTYPOLOGY[MACROTYPOLOGY["AGENCY"] = 5] = "AGENCY";
  MACROTYPOLOGY[MACROTYPOLOGY["ACTIVITY"] = 6] = "ACTIVITY";
})(MACROTYPOLOGY || (MACROTYPOLOGY = {}));